<template>
    <div class="screenSaver" @click="handleSkip">
        <transition-group class="window" tag="div" name="window">
            <section :key="0" class="screen one" v-show="index ===0">
                <div class="innerPage bgWhite pad75">
                    <img  class="library-logo" v-if="libraryInfoData.htmlInfo.image" :src="imgPath+libraryInfoData.htmlInfo.image"  alt="">
                    <img  class="library-logo" v-else src="../../assets/images/libImg.jpg"  alt="">

                    <article class="library-indroduce">
                        <h4 class="h4">本馆介绍</h4>
                        <p class="p" v-if="libraryInfoData.htmlInfo.content" v-html="libraryInfoData.htmlInfo.content && libraryInfoData.htmlInfo.content.length>420?libraryInfoData.htmlInfo.content.slice(0,420)+'...':libraryInfoData.htmlInfo.content"></p>
                        <p class="p" v-else>暂无简介</p>
                    </article>
                </div>
            </section>
            <section :key="1" class="screen two" v-show="index ===1">
                <div class="innerPage">
                    <div class="innerLeft">
                        <div class="info-top">
                            <h4 class="h4">本馆介绍</h4>
                            <p class="p" v-if="libraryInfoData.info">馆号：{{libraryInfoData.info.libCode}}</p>
                            <p class="p" v-if="libraryInfoData.info">馆名：{{libraryInfoData.info.libName}}</p>
                            <p class="p" >馆别：{{libLevel}}</p>
                            <p class="p" v-if="libraryInfoData.info">电话：{{libraryInfoData.info.phone}}</p>
                            <p class="p" v-if="libraryInfoData.info">地址： {{libraryInfoData.info.address.length>40?libraryInfoData.info.address.slice(0,40)+'...':libraryInfoData.info.address}}</p>
                        </div>
                        <div class="info-middle">
                            <h4 class="h4">藏书统计</h4>
                            <p class="p">纸质藏书：{{bookNum}}册</p>
                            <p class="p">电子藏书：{{ebookNum}}种</p>
                            <p class="p">视频资源：{{videosNum}}条</p>
                        </div>
                        <div class="info-bottom">
                            <h4 class="h4">读者信息</h4>
                            <p class="p">注册读者：{{registeredReaderNum}}人</p>
                            <p class="p">服务读者：{{serviceReaderNum}}人</p>
                            <p class="p">访问人次：{{accessReadersNum}}人</p>
                        </div>
                    </div>
                    <div class="innerRight">
                        <h4 class="h4">开放时间</h4>
                        <p>今日开放：<span style="margin-left:0;margin-right:20px">{{today}}</span></p>
                        <p>定期开放：</p>
                        <p class="indent" v-for="(item,index) in weeks" :key="index">
                            {{item.days}}<span>{{item.openTime}}</span>
                            <!--<span>09:00-12:00</span>-->
                            <!--<span>13:00-17:00</span>-->
                        </p>

                    </div>
                </div>
            </section>
            <section :key="2" class="screen" v-show="index ===2">
                <div class="innerPage bgWhite threePage" v-if="libLevel=='共享书屋'">
                    <h4 class="h4">借阅须知</h4>

                    <p>一、借阅范围 : 平台上全部共享书屋。 </p>

                    <p>二、借阅凭证 : 本人二代身份证或注册账号。 </p>

                    <p>三、借阅数量 : 每证{{libraryInfoData.info?libraryInfoData.info.maxSum:0}}册以内。 </p>

                    <p>四、借阅收费 : 免费或年费。</p>

                    <p>五、借阅期限 : {{libraryInfoData.info?libraryInfoData.info.freeRentDate:0}}天，还书后可再借。</p>

                    <p>六、逾期处理 : 逾期未还，按读者主动购买该图书处理，平台将完成自动扣款。</p>

                    <p>七、损坏赔偿 : 损坏图书，照价赔偿;有溢价的图书，照溢价后赔偿。</p>

                    <p v-if="otherProvisions">八、其他规定 :{{otherProvisions}}。 </p>
                </div>
                <div class="innerPage bgWhite threePage" v-else>
                    <h4 class="h4">借阅须知</h4>

                    <p>一、借阅范围 : 平台上全部图书馆和书屋。</p>

                    <p>二、借阅凭证 : 本人二代身份证或注册账号。 </p>

                    <p>三、借阅数量 : 每证{{libraryInfoData.info?libraryInfoData.info.maxSum:0}}册以内。 </p>

                    <p>四、借阅收费 : 免费。</p>

                    <p  v-if="libraryInfoData.info && libraryInfoData.info.needDeposit===1">五、借阅押金 : 有押金。</p>
                    <p v-else>五、借阅押金 :无押金。</p>

                    <p>六、借阅期限 : {{libraryInfoData.info?libraryInfoData.info.freeRentDate:0}}天，续借延期{{libraryInfoData.info?libraryInfoData.info.freeRentDate:0}}天。</p>
                    <p>七、逾期处理 : {{libraryInfoData.info?libraryInfoData.info.rent:0}}元/册/天。</p>
                    <p>八、损坏赔偿 : 损坏图书，照价赔偿;有溢价的图书，照溢价后赔偿。</p>
                    <p v-if="otherProvisions">九、其他规定 : {{ otherProvisions }}</p>
                </div>
            </section>
        </transition-group>
    </div>
</template>

<script>
    import {api,imgPath} from '../../common/config.js';
    import {store} from '../../store/store.js';
    import {ajaxUtil} from '../../common/AjaxUtil.js';
    export default {
        name: "screenSaver",
        data(){
            return{
              imgPath:imgPath,
                index: 0,
                timer: null,
                libId:'',
                fromSearch:'',
                libCode:'',
                latLng:'',
                libLevel:'',
                libraryInfoData:{
                    'htmlInfo':{'image':null}
                },
                bookNum:'',
                ebookNum:'',
                videosNum:'',
                registeredReaderNum:'',
                serviceReaderNum:'',
                accessReadersNum:'',
                today:'',
                libraryBuniessData:'',
                weeks:[
                    {days:'周一',openTime:''},
                    {days:'周二',openTime:''},
                    {days:'周三',openTime:''},
                    {days:'周四',openTime:''},
                    {days:'周五',openTime:''},
                    {days:'周六',openTime:''},
                    {days:'周日',openTime:''}
                ],
                otherProvisions:'',//其他规定
            }
        },
        mounted(){
            this.libLevel = this.$route.query.libLevel || store.library.libraryLevel || '';
            this.latLng = this.$route.query.latLng || store.localtionArea.latLng || '';
            this.libraryname = this.$route.query.libraryname || store.library.name || '';
            this.fromSearch = this.$route.query.fromSearch || 0;
            this.libId = this.$route.query.libId || store.library.id || '';
            this.libCode = this.$route.query.libCode || this.$route.query.hallCode || '';
            this.getIndroduce();
            this.getNumber();
            this.getOPenTime();
            this.getRegulation();
             this.runPlay()
        },
        methods:{
            runPlay () {
                this.timer = setInterval(() => {
                    this.index++;
                    if (this.index === 3) {
                        this.index = 0
                    }
                }, 30000)
            },
            handleSkip () {
                this.$router.push('OPACIndex');
            },
            /**获取简介**/
            getIndroduce(){
                let url = api.library.info.replace('{fromSearch}', this.fromSearch).replace('{flag}',1).replace('{libId}', this.libId).replace('{lngLat}', this.latLng);
                ajaxUtil.ajaxJson(url, null, "GET", (data) => {
                    this.libraryInfoData = data;
                }, null, this);
            },
            /**获取馆藏信息及读者人次**/
            getNumber(){
               let url = api.library.libraryNumber.replace('{libCode}',this.libCode);
               ajaxUtil.ajaxJson(url, null, "GET",(data)=>{
                   this.bookNum = data.bookNum || 0;
                   this.ebookNum = data.ebookNum || 0;
                   this.videosNum = data.videosNum || 0;
                   this.registeredReaderNum = data.registeredReaderNum|| 0;
                   this.serviceReaderNum = data.serviceReaderNum || 0;
                   this.accessReadersNum = data.accessReadersNum || 0;
                },null,this)
            },
            /**获取开放信息***/
            getOPenTime(){
                var url = api.library.libLight.replace('{libCode}', this.libCode);
                ajaxUtil.ajaxJson(url, null, "GET", (data) => {
                    this.libraryBuniessData = data.lightTimeNew;
                    this.today = this.libraryBuniessData.today;
                    this.weeks[0].openTime = this.libraryBuniessData.week.monday;
                    this.weeks[1].openTime = this.libraryBuniessData.week.tuesday;
                    this.weeks[2].openTime = this.libraryBuniessData.week.wednesday;
                    this.weeks[3].openTime = this.libraryBuniessData.week.thursday;
                    this.weeks[4].openTime = this.libraryBuniessData.week.friday;
                    this.weeks[5].openTime = this.libraryBuniessData.week.saturday;
                    this.weeks[6].openTime = this.libraryBuniessData.week.sunday;
                }, null, this);
            },
            /**获取其他规定**/
            getRegulation(){
                let url = api.library.regulation.replace('{libCode}', this.libCode);
                ajaxUtil.ajaxJson(url, null, "GET",(data)=>{
                    if(data.regulation){
                        this.otherProvisions = data.regulation
                    }
                },null,this)
            }
        },
    }
</script>

<style scoped lang="sass">
.screenSaver
  width: 100%
  height: 100%
  overflow: hidden
  background: url('../../assets/images/screenBg.jpg')
  position: fixed
  z-index: 100000000
  .window
    width: 300%
    height: 100%
  .screen
    width: 33.333333%
    height: 100%
    text-align: center
    .h4
        font-size: 28px
        color: #333333
        font-weight: normal
        text-align: center
    .p
        font-size: 20px
        color: #666666
        text-align: left
        line-height: 44px
        margin-top: 20px
    .bgWhite
        background: #ffffff
    .pad75
        padding: 75px
    .innerPage
        width: 1450px
        height: 750px
        margin: 165px auto 0
        box-sizing: border-box
        border-radius: 10px
        .library-logo
           width: 600px
           height: 600px
           float: left
           margin-right: 75px
        .library-indroduce
           float: left
           width: 625px
        .innerLeft
           float: left
           div
             width: 715px
             background: #fff
             border-radius: 10px
             box-sizing: border-box
             padding: 40px 0 0 76px
             p
              line-height: 36px
              margin-top: 0px
           .info-top
             margin-bottom: 20px
             height: 279px
           .info-middle
             margin-bottom: 20px
             height: 207px
           .info-bottom
             height: 225px
        .innerRight
           float: left
           height: 750px
           width: 715px
           margin-left: 20px
           border-radius: 10px
           background: #fff
           box-sizing: border-box
           padding: 40px 140px 0
           h4
               margin-bottom: 5px
           p
             font-size: 20px
             color: #666666
             line-height: 56px
             text-align: left
             span
                 margin: 0 20px
           .indent
               text-indent: 40px
    .threePage
        padding: 75px 420px 0 420px
        p
            font-size: 20px
            color: #666666
            line-height: 60px
            text-align: left
.window-enter-active
  transition: all 1s ease

.window-leave-active
  transition: all 1s ease

.window-enter
  transform: translateX(100%)

.window-leave-to
  transform: translateX(-100%)
</style>
